<template>
  <div class="hotLiveBroadcastingRoom">
    <div class="hot-liveroom-title">推荐直播</div>
    <div class="hot-room-main">
      <!-- <router-link
        :to="`/liveMatchesTwo/${item.anchorid}`"
        target="_blank" -->
      <div @click="enterRoom(item, true)" class="hot-room-item" v-for="(item, index) in hotLives" :key="index">
        <div class="item-tags">
          <div class="item-tag" :style="{ background: item.tag_color }" v-show="item.tag_title">{{ item.tag_title }}</div>
          <div class="item-tag" :style="{ background: '#FF69B4' }" v-show="item.guess_tag">竞猜</div>
        </div>
        <div class="item-img" :title="item.title">
          <!-- <img :src="item.thumb || item.thumb_url || images" alt /> -->
          <div class="item-live-bg" :style="{ backgroundImage: `url(${item.thumb || item.thumb_url || images})` }"></div>
        </div>

        <div class="item-content">
          <div class="content-name-top">{{ item.title }}</div>
          <div class="content-bottom">
            <img class="item-anchor-avatar" :src="item.anchor_avatar" alt />
            <span class="item-anchor-name item-lives-info">{{ item.anchor_name }}</span>
            <img class="item-anchor-icon" src="./img/live_heat.png" alt />
            <span class="item-lives-info" v-if="hotIndex == item.anchorid">{{ $bigNumber(hot) || 0 }}</span>
            <span class="item-lives-info" v-else>{{ $bigNumber(item.hot) || 0 }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { enterRoom } from "@/util/enterRoomTicket";
import { mapState } from "vuex";
export default {
  props: {
    hotLives: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  inject: ["reload"],
  computed: {
    ...mapState(["hot"]),
  },
  data() {
    return {
      images: require("../../components/live-item/queshengye.jpg"),
      hotIndex: "",
    };
  },
  mounted() {
    this.hotIndex = this.$route.params.id;
  },
  methods: {
    enterRoom,
    // goDetail(id) {
    //   this.$router.replace(`/liveMatchesTwo/${id}`);
    //   // location.reload();
    //   this.reload();
    // },
    // hotCount(hot) {
    //   if (hot < 10000) {
    //     return hot;
    //   } else {
    //     const num = hot / 10000;
    //     return `${num.toFixed(1) + 0.1}w`;
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.hotLiveBroadcastingRoom {
  padding: 0.16rem 0.08rem 0.05rem 0.24rem;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-bottom: 32px;

  .hot-liveroom-title {
    font-size: 24px;
    color: #333333;
    font-weight: 500;
    margin-bottom: 16px;
  }

  .hot-room-main {
    width: 100%;
    // height: 100%;
    display: flex;
    flex-wrap: wrap;
    // margin-top: -10px;
  }
  .hot-room-item {
    position: relative;
    width: 2.8rem;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0.05rem;
    margin-right: 0.16rem;
    margin-bottom: 0.16rem;
    .item-tags {
      position: absolute;
      top: 0.16rem;
      right: 0.16rem;
      font-weight: 600;
      font-size: 0.14rem;
      color: #fff;
      z-index: 99;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      .item-tag {
        padding: 0.02rem 0.08rem;
        border-radius: 0.04rem;
        margin-bottom: 0.06rem;
      }
    }

    // &:nth-child(4n) {
    //   margin-right: 0;
    // }

    &:hover .item-live-bg {
      transform: scale(1.1);

      &::before {
        content: "";
        width: 0.48rem;
        height: 0.48rem;
        display: block;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 2;
        background: url("./img/pause.png") no-repeat center center / contain !important;
        pointer-events: none;
      }
    }

    .item-img {
      width: 100%;
      height: 1.6rem;
      overflow: hidden;
      position: relative;
      border-radius: 0.05rem 0.05rem 0 0;

      .item-live-bg {
        width: 100%;
        height: 100%;
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-position: center center;
        cursor: pointer;
        transition: all 0.5s;
      }
    }

    .item-content {
      width: 100%;
      padding: 0.12rem 0.16rem;

      .content-name-top {
        width: 100%;
        line-height: 0.22rem;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 0.16rem;
        color: #333333;
        font-weight: 500;
        margin-bottom: 0.08rem;
      }

      .content-bottom {
        width: 100%;
        display: flex;
        align-items: center;
      }

      .item-anchor-avatar {
        width: 0.24rem;
        height: 0.24rem;
        border-radius: 50%;
        margin-right: 0.08rem;
      }

      .item-lives-info {
        font-size: 0.14rem;
        color: #666666;
      }

      .item-anchor-name {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .item-anchor-icon {
        width: 0.16rem;
        height: 0.16rem;
        margin-right: 0.04rem;
        margin-left: 0.16rem;
      }
    }
  }
}
</style>
